/* ============================================================================
   ÉVÉNEMENTS — el embudo de CUSTOM, preparado y sin enviar nada
   ----------------------------------------------------------------------------
   Queremos poder saber dónde abandona la gente y, más adelante, poder decirle
   « votre création vous attend ». Las dos cosas necesitan lo mismo: que los
   momentos del recorrido estén NOMBRADOS y ocurran en un solo sitio.

   LO QUE ESTO NO HACE, y es lo importante:
   · no manda ni un byte a ningún sitio. No hay proveedor de analítica, no hay
     endpoint, no hay clave. Sólo un bus y un adaptador vacío.
   · no manda recordatorios. Ni correo, ni SMS, ni WhatsApp. Para eso hacen
     falta identidad, consentimiento y un canal configurado, y no hay ninguno
     de los tres.
   · no guarda el CONTENIDO del diseño. Un evento lleva el designId y el
     producto; el texto que ha escrito el cliente y su foto no son telemetría.

   Cuando exista un destino real se escribe UN adaptador y se enchufa aquí.
   Nada de lo que llama a estas funciones tendrá que cambiar.
   ========================================================================== */

const EVENEMENTS = (() => {
'use strict';

/** Los momentos del recorrido. Cerrado a propósito: un nombre libre por
 *  llamada acaba en tres variantes del mismo evento y un embudo inservible. */
const TIPOS = Object.freeze({
  DESIGN_STARTED: 'design_started',
  DESIGN_MODIFIED: 'design_modified',
  DESIGN_SAVED: 'design_saved',
  DESIGN_PREVIEWED: 'design_previewed',
  DESIGN_ABANDONED_CANDIDATE: 'design_abandoned_candidate',
  DESIGN_RESUMED: 'design_resumed',
  DESIGN_ADDED_TO_CART: 'design_added_to_cart',
  DESIGN_PURCHASED: 'design_purchased',
});

/* Cuánta inactividad convierte una sesión en candidata a abandonada. NO es una
   regla de marketing: es el umbral a partir del cual tiene sentido preguntarse
   si alguien se fue. La campaña —si algún día la hay— decide otra cosa, y por
   eso esto es configurable y no una constante escondida. */
let _inactividadMs = 30 * 60 * 1000;

const _adaptadores = [];
const _cola = [];
const MAX_COLA = 50;

/** Enchufa un destino. Hoy no hay ninguno. */
function registrar(adaptador) {
  if (typeof adaptador === 'function') _adaptadores.push(adaptador);
  return () => {
    const i = _adaptadores.indexOf(adaptador);
    if (i >= 0) _adaptadores.splice(i, 1);
  };
}

/**
 * @param {string} tipo  uno de TIPOS
 * @param {object} datos  { designId, productHandle, engine, ... }. Nunca el
 *   contenido del diseño.
 */
function emitir(tipo, datos = {}) {
  if (!Object.values(TIPOS).includes(tipo)) return null;

  const evento = Object.freeze({
    type: tipo,
    at: Date.now(),
    designId: datos.designId ?? null,
    productHandle: datos.productHandle ?? null,
    engine: datos.engine ?? null,
    // Un hueco para lo que cada evento necesite, sin contenido del cliente.
    meta: datos.meta ?? null,
  });

  _cola.push(evento);
  if (_cola.length > MAX_COLA) _cola.shift();

  for (const a of _adaptadores) {
    try { a(evento); } catch (e) { /* un destino roto no rompe el editor */ }
  }
  return evento;
}

/* ------------------------------------------------------- abandono ------- */

let _reloj = null;
let _ultimo = null;

/**
 * Vigila la inactividad de UNA sesión. No decide que se ha abandonado: emite
 * « candidata », que es lo único que se puede afirmar desde el navegador —
 * quien sepa si hubo pedido es el backend, y no lo hay.
 */
function vigilar(datos) {
  _ultimo = datos;
  tocar();
}

function tocar() {
  clearTimeout(_reloj);
  if (!_ultimo) return;
  _reloj = setTimeout(() => {
    emitir(TIPOS.DESIGN_ABANDONED_CANDIDATE, {
      ..._ultimo, meta: { inactividadMs: _inactividadMs },
    });
  }, _inactividadMs);
}

function dejarDeVigilar() { clearTimeout(_reloj); _ultimo = null; }

const configurar = ({ inactividadMs } = {}) => {
  if (Number.isFinite(inactividadMs) && inactividadMs > 0) _inactividadMs = inactividadMs;
};

/** Lo emitido en esta página. Para depurar y para el laboratorio. */
const historial = () => _cola.slice();

return { TIPOS, emitir, registrar, vigilar, tocar, dejarDeVigilar, configurar, historial };
})();

if (typeof window !== 'undefined') window.EVENEMENTS = EVENEMENTS;
